import React from 'react';
import type { ViewProps } from 'react-native';
import { Pressable, StyleSheet, View } from 'react-native';
import type { IconName } from '@sweetgreen/garnish';
import {
  Icon,
  ListAction,
  theme,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

export type CreditMenuProps = {
  readonly iconName: IconName;
  readonly title?: string | null;
  readonly subtitle?: string | null;
  readonly onPress: () => void;
} & ViewProps;

export const CreditMenuItem = ({
  testID,
  iconName,
  title,
  subtitle,
  onPress,
  accessibilityLabel,
  accessibilityHint,
}: CreditMenuProps) => {
  const { isMobile } = useBreakpointHelpers();

  return (
    <Pressable
      testID={testID}
      accessibilityRole="link"
      accessibilityLabel={accessibilityLabel}
      accessibilityHint={accessibilityHint}
      onPress={onPress}
    >
      <ListAction.Wrapper hasPressableStyles>
        <View style={styles.container}>
          <ListAction.Icon iconName={iconName} />
          <View style={styles.content}>
            <ListAction.Text>
              {[title, subtitle].filter(Boolean).join(isMobile ? '\n' : ' – ')}
            </ListAction.Text>
          </View>
          <Icon
            name="IconCaretRight"
            color={theme.colors.NEUTRAL_2}
            width={18}
            height={18}
          />
        </View>
      </ListAction.Wrapper>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'center',
    paddingVertical: theme.spacing.small,
  },
  content: {
    flex: 1,
  },
});
